import { Pipe, PipeTransform } from '@angular/core';
import { DayOfWeek } from '@app/features/horaires/schedules.model';

@Pipe({
  name: 'dayOfWeekLabel',
})
export class DayOfWeekLabelPipe implements PipeTransform {
  transform(value: DayOfWeek): string {
    switch (value) {
      case 'MONDAY':
        return 'Lundi';
      case 'TUESDAY':
        return 'Mardi';
      case 'WEDNESDAY':
        return 'Mercredi';
      case 'THURSDAY':
        return 'Jeudi';
      case 'FRIDAY':
        return 'Vendredi';
      case 'SATURDAY':
        return 'Samedi';
      case 'SUNDAY':
        return 'Dimanche';
      default:
        return '';
    }
  }
}
